import { render, staticRenderFns } from "./TransaccionesCard.vue?vue&type=template&id=c387d9fa"
import script from "./TransaccionesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TransaccionesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports